// extracted by mini-css-extract-plugin
module.exports = {"ratingInfoContainer":"RatingSection_ratingInfoContainer__Ji4Gl","expertQuote":"RatingSection_expertQuote___tQ4s","shimmer":"RatingSection_shimmer__aTCri"};